import { Component } from '@angular/core';
import { LoopBackAuth, AgentCommissionApi } from '../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { BasicList } from '../../../classes';
import { USER_ROLES, COMMISSION_SOURCE } from '../../../enums';
import { UserProfileComponent } from '../../administration/users/user-profile/user-profile.component';
import { ProductsService } from '../../../services';

@Component({
  selector: 'app-commissions',
  templateUrl: './commissions.component.html',
  styleUrls: ['./commissions.component.css']
})
export class CommissionsComponent extends BasicList {
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  COMMISSION_SOURCE: typeof COMMISSION_SOURCE = COMMISSION_SOURCE;
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'referenceNumber', placeholder: 'Order Reference', exact: true },
      { name: 'partnerSource', placeholder: 'Agent Source', exact: true },
      { name: 'partnerId', placeholder: 'Agent id', exact: true }
    ],
    filters: {}
  };

  constructor(
    private agentCommissionApi: AgentCommissionApi,
    private loopBackAuth: LoopBackAuth,
    private modalService: BsModalService,
    private productService: ProductsService
  ) {
    super();
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.params = {
      where: {
        partnerId: this.getUser().partnerId || undefined
      },
      order: 'dateCreated DESC'
    };
    if (this.getUser().partnerId) {
      this.searchSettings.searchableFields.pop();
    }
    this.settings = {
      createComponent: undefined,
      api: {
        paginate: this.agentCommissionApi.search.bind(this.agentCommissionApi),
        deleteById: this.agentCommissionApi.deleteById.bind(this.agentCommissionApi)
      },
      ModalService: this.modalService
    };
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  userDetails(data): void {
    if (!data.partnerSource) {
      return;
    }
    const userModal = this.settings.ModalService
      .show(UserProfileComponent, {
        initialState: { data: { partnerId: data.partnerSource } }
      });
    const subscription = this.modalService.onHidden
      .subscribe(() => {
        if (userModal.content) {
          if (userModal.content.result) {
            // DO SOMETHING
          } else {
            // DO SOMETHING
          }
        }
        subscription.unsubscribe();
      });
  }
}
